/**
 * useFileBlob — laedt ein PropertyFile als Blob-URL ueber den API-Client.
 *
 * Saubere Lifecycle-Verwaltung: revoke ObjectURL beim Unmount oder File-Wechsel,
 * um Memory-Leaks zu vermeiden. Wird sowohl von der Preview als auch von der
 * Thumbnail-Generierung im Liste-Modus genutzt.
 */
import { useEffect, useState } from 'react';
import { useApi } from '@/shared/api';

interface State {
  url: string | null;
  loading: boolean;
  error: Error | null;
}

export function useFileBlob(propertyId: string, fileId: string | null): State {
  const api = useApi();
  const [state, setState] = useState<State>({ url: null, loading: false, error: null });

  useEffect(() => {
    if (!fileId) {
      setState({ url: null, loading: false, error: null });
      return;
    }
    let cancelled = false;
    let createdUrl: string | null = null;
    setState((s) => ({ ...s, loading: true, error: null }));
    api.propertyFiles
      .download(propertyId, fileId)
      .then((blob) => {
        if (cancelled) return;
        createdUrl = URL.createObjectURL(blob);
        setState({ url: createdUrl, loading: false, error: null });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setState({
          url: null,
          loading: false,
          error: err instanceof Error ? err : new Error('Preview konnte nicht geladen werden'),
        });
      });
    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [api, propertyId, fileId]);

  return state;
}
